import React from 'react';
import './Experience.css';

function Experience() {
  // const experiences = [
  //   {
  //     id: 1,
  //     company: 'intenship',
  //     position: ' Web Developement',
  //     duration: '6months',
  //     description: 'Developed and maintained web applications using React.js. Collaborated with cross-functional teams to deliver high-quality software solutions.',
  //     technologies: ['React', 'JavaScript', 'Node.js', 'MongoDB']
  //   },
  //   {
  //     id: 2,
  //     company: 'Inclination IT Innovation Pvt. Ltd',
  //     position: 'full stack developer',
  //     duration: 'Sep 2023 – Oct 2024',
  //     description: 'Built responsive websites and implemented new features for existing web applications.',
  //     technologies: ['JavaScript', 'HTML', 'CSS', 'jQuery']
  //   },
  //   {
  //     id: 3,
  //     company: 'db4 Cloud Technologies Pvt. Ltd',
  //     position: 'Associate Software Engineer',
  //     duration: 'Nov2024 to presents',
  //     description: 'Assisted in the development of web applications and learned industry best practices.',
  //     technologies: ['HTML', 'CSS', 'JavaScript']
  //   }
  // ];



  const experiences = [
  {
    id: 1,
    company: 'Internship',
    position: 'Web Developer',
    duration: '6 months',
    description:
      'Developed and maintained web applications using React.js and Node.js. Collaborated with cross-functional teams to deliver high-quality software solutions.',
    technologies: ['HTML', 'CSS','React.js', 'JavaScript', 'Node.js', 'MongoDB']
  },
  {
    id: 2,
    company: 'Inclination IT Innovation Pvt. Ltd',
    position: 'Full Stack Developer',
    duration: 'Sep 2023 – Oct 2024',
    description:
      'Built responsive websites, implemented new features for existing web applications, and optimized performance for better user experience.',
    technologies: ['JavaScript', 'HTML', 'CSS', 'jQuery', 'React.js', 'Node.js', 'MongoDB']
  },
  {
    id: 3,
    company: 'db4 Cloud Technologies Pvt. Ltd',
    position: 'Associate Software Engineer',
    duration: 'Nov 2024 – Present',
    description:
      'Developing scalable web and mobile applications, integrating APIs, and ensuring secure, maintainable, and high-performing solutions.',
    technologies: ['React.js', 'React Native', 'Node.js', 'MongoDB', 'JavaScript']
  }
];

  return (
    <section className="experience-section">
      <h1>Professional Experience</h1>
      <div className="timeline">
        {experiences.map(exp => (
          <div key={exp.id} className="timeline-item">
            <div className="timeline-content">
              <h2>{exp.position}</h2>
              <h3>{exp.company}</h3>
              <p className="duration">{exp.duration}</p>
              <p className="description">{exp.description}</p>
              <div className="tech-stack">
                {exp.technologies.map((tech, index) => (
                  <span key={index} className="tech-tag">{tech}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Experience;